import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaIsraelSupport: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-israel-comprehensive-support.excalidraw"
    title="Everything Australia Does to Support Israel"
    subtitle="F-35 parts, arms exports, intelligence sharing, diplomatic support -- with costs and timelines (Oct 2023 - March 2026)"
  />
);

export default AustraliaIsraelSupport;
